/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'GoalPanel.header.title': 'Ziel',
  'goal-panel.goal-panel-expand-field-button.show-less-collapsed-label': 'Weitere Felder anzeigen',
  'goal-panel.goal-panel-expand-field-button.show-more-collapsed-label': 'Weniger anzeigen',
  'goal-panel.goal-panel-tabs.about-tab-title': 'Info',
  'goal-panel.goal-panel-tabs.jira-align-title': 'Jira Align',
  'goal-panel.goal-panel-tabs.jira-title': 'Jira',
  'goal-panel.goal-panel-tabs.projects-title': 'Projekte',
  'goal-panel.goal-panel-tabs.updates-tab-title': 'Updates',
  'goal-panel.goal-title.edit-button-label': 'Titel des Ziels bearbeiten',
  'goal-panel.goal-title.update-error-description': 'Der Inhalt von {goalName} konnte nicht aktualisiert werden',
  'goal-panel.goal-title.update-error-title': 'Etwas ist schiefgelaufen',
  'goal-panel.goal-title.validation-message': 'Geben Sie bitte einen Titel für Ihr Ziel ein.',
};
